var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoProyecto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6968_92836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.17181 1.68689H2.39056C2.00224 1.68689 1.68744 2.00169 1.68744 2.39001V7.17126C1.68744 7.55959 2.00224 7.87439 2.39056 7.87439H7.17181C7.56014 7.87439 7.87494 7.55959 7.87494 7.17126V2.39001C7.87494 2.00169 7.56014 1.68689 7.17181 1.68689Z",
    fill: "#414141",
    stroke: "#414141",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6093 1.68689H10.8281C10.4397 1.68689 10.1249 2.00169 10.1249 2.39001V7.17126C10.1249 7.55959 10.4397 7.87439 10.8281 7.87439H15.6093C15.9976 7.87439 16.3124 7.55959 16.3124 7.17126V2.39001C16.3124 2.00169 15.9976 1.68689 15.6093 1.68689Z",
    fill: "#414141",
    stroke: "#414141",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17181 10.1246H2.39056C2.00224 10.1246 1.68744 10.4394 1.68744 10.8278V15.609C1.68744 15.9973 2.00224 16.3121 2.39056 16.3121H7.17181C7.56014 16.3121 7.87494 15.9973 7.87494 15.609V10.8278C7.87494 10.4394 7.56014 10.1246 7.17181 10.1246Z",
    fill: "#414141",
    stroke: "#414141",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6093 10.1246H10.8281C10.4397 10.1246 10.1249 10.4394 10.1249 10.8278V15.609C10.1249 15.9973 10.4397 16.3121 10.8281 16.3121H15.6093C15.9976 16.3121 16.3124 15.9973 16.3124 15.609V10.8278C16.3124 10.4394 15.9976 10.1246 15.6093 10.1246Z",
    fill: "#414141",
    stroke: "#414141",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6968_92836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoProyecto);
export default __webpack_public_path__ + "static/media/icono-proyecto.8ffd20cdc0f89511ab1ffd407e0bf781.svg";
export { ForwardRef as ReactComponent };